import { pathSubscription, parametric, subscription } from 'nike-re-framejs';
import Immutable, { Map } from 'immutable';
import { EXPANDED_MATCH_TICKETS } from './handlers';
import { MATCH_TICKETS } from './constants';
import { allVisibleMatches$ } from '../../subs';
import { MatchIdentity } from '../../dto';
import { sports$ } from '../../push/overview/subs';

export const ticketusActiveMark$ = pathSubscription(['ticketus', 'active', 'mark']);

export const matchActiveTickets$$ = matchId =>
    pathSubscription(['ticketus', 'active', 'sportEventToTickets', matchId], Immutable.List());

export const matchTicketsBetTickets$$ = betId =>
    pathSubscription(['ticketus', 'active', 'match', 'betIdsToPickIds', betId]);

export const expanedMatchTicketsId$$ = pathSubscription(EXPANDED_MATCH_TICKETS);

export const expandedMatchTickets$$ = parametric(matchId =>
    subscription(activeMatchId => activeMatchId === matchId, expanedMatchTicketsId$$)
);

export const matchTicketsVisible$$ = parametric(matchId =>
    subscription(
        (matchTickets, expandedTickets) => expandedTickets && matchTickets?.size,
        matchActiveTickets$$(matchId),
        expandedMatchTickets$$(matchId)
    )
);

export const matchesOnTickets$$ = subscription(
    (allMatchIds: Map<string, MatchIdentity>, matchesOnTickets: Map<string, MatchIdentity>) =>
        (matchesOnTickets && allMatchIds?.filter((v, k) => matchesOnTickets.has(k)).map(m => Map(m))) || Map,
    allVisibleMatches$,
    pathSubscription(MATCH_TICKETS)
);

export const matchesOnTicketsCount$ = subscription(
    (matchesOnTickets: Map<string, MatchIdentity>) => matchesOnTickets?.size || 0,
    matchesOnTickets$$
);

export const sportsOnTickets$$ = subscription(
    (matchesOnTickets: Map<string, any>, sports: Map<string, any>) =>
        matchesOnTickets?.size && sports?.size
            ? matchesOnTickets
                  .groupBy(m => m.get('sportId'))
                  .filter((v, k) => sports.get(k))
                  .sortBy((m, k) => sports.find((s, id) => id === k)?.get('order'))
                  .map(s => s.keySeq().toArray())
            : null,
    matchesOnTickets$$,
    sports$
);

export const sportNameById$$ = parametric(sportId =>
    subscription(
        (sports: Map<string, any>) =>
            sports
                .get(sportId)
                ?.get('slug')
                .substring(1),
        sports$
    )
);
